export const KEYS = {
  FILE: 'FILE',
  IMAGE_URL: 'IMAGE_URL',
};

export const IMAGE_INPUT_TYPE = KEYS;

const convertToOption = (item) => ({
  label: `IMAGE_INPUT_TYPE.${item}`,
  value: item,
});

const LIST = Object.keys(KEYS);

export const IMAGE_INPUT_TYPE_OPTIONS = LIST.map(convertToOption);

export type IMAGE_INPUT_TYPE = (typeof LIST)[number] | undefined;
